<admin-page-simple-content
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Library: Products'"
    [icon]="'card_giftcard'"
>
    <div class="content">
        <div class="filter">
            <mat-form-field class="dense-2" floatLabel="always">
                <mat-label>Filter</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput [(ngModel)]="filter" (keydown)="updateFilter()" (keyup)="updateFilter()" />
                @if (products.length) {
                    <mat-hint>Showing {{ filteredProducts.length }} / {{ products.length }} products</mat-hint>
                }
            </mat-form-field>
            <mat-checkbox [(ngModel)]="limitShownNumber" (change)="updateFilter()">Limit shown results to {{maxResultCount}} to avoid performance issue</mat-checkbox>
        </div>

        @for (product of filteredProducts; track product) {
            <div class="product-info">
                <h2 class="label"><admin-fuzzy-sort-result-highlight [result]="product" [fuzzySearchKeys]="fuzzySearchKeys" [key]="'label'"/></h2>
                <div class="product-thumbnail">
                    @if (product.obj.thumbnail) {
                        <img
                            [attr.alt]="'Thumbnail of ' + product.obj.label"
                            loading="lazy"
                            [attr.src]="getThumbnailUrlWithStoreId(product.obj)"
                        />
                    }
                    @if (!product.obj.thumbnail) {
                        <span>No thumbnail</span>
                    }
                </div>
                <div class="info">
                    <div class="admin-field">
                        <span class="label">Module</span>
                        <span class="value"
                        ><code adminCopyToClipboard>{{ product.obj.module }}</code></span
                        >
                    </div>
                    <div class="admin-field">
                        <span class="label">ID</span>
                        <span class="value"
                        ><code adminCopyToClipboard [textToCopy]="product.obj.id"><admin-fuzzy-sort-result-highlight [result]="product" [fuzzySearchKeys]="fuzzySearchKeys" [key]="'id'"/></code></span
                        >
                    </div>
                    <div class="admin-field">
                        <span class="label">PLU</span>
                        <span class="value"
                        ><code adminCopyToClipboard>{{ product.obj.plu }}</code></span
                        >
                    </div>
                    <div class="admin-field">
                        <span class="label">Links</span>
                        <span class="value">
                            <ul class="link-list">
                                <li>
                                    <a
                                        tabindex="0"
                                        [routerLink]="['/stores', storeId, 'library', 'product']"
                                        [queryParams]="{ id: product.obj.id }"
                                    >Themes</a>
                                </li>
                                <li>
                                    <a tabindex="0" target="_blank" [href]="getGitlabLink(product.obj.id)">GitLab</a>
                                </li>
                            </ul>
                        </span>
                    </div>
                </div>
            </div>
        }
    </div>
</admin-page-simple-content>
